import ProjectPlanTabContainer from '../../../../../containers/SingleSheet/ProjectPlanTabContainer'

type ProjectPlanTabProps = {
  uuid: string
}
export const ProjectPlanTab = ({ uuid }: ProjectPlanTabProps) => {
  return <ProjectPlanTabContainer wbsItemUuid={uuid} />
}
